export const PREFIXES = {
    TRIGGER: 'TRIGGER',
    REQUEST: 'REQUEST',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    FULFILL: 'FULFILL',
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actionTypePrefixes.ts